/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { HelpHelpCenterAri } from '@atlassian/ari/help/help-center';
import { fg } from '@atlassian/jira-feature-gating';
import type { HelpCenterSettingsEmailEntryPointQuery as HelpCenterSettingsEmailEntryPointQueryType } from './__generated__/HelpCenterSettingsEmailEntryPointQuery.graphql.ts';
import HelpCenterSettingsEmailEntryPointQueryParameters from './__generated__/HelpCenterSettingsEmailEntryPointQuery$parameters.ts';

type HelpCenterSettingsEmailAppEntryPointComponent = EntryPointComponent<
	{ emailPreviewQuery: HelpCenterSettingsEmailEntryPointQueryType },
	{},
	{},
	{} | null
>;

export const HelpCenterSettingsEmailAppEntryPoint: EntryPoint<
	HelpCenterSettingsEmailAppEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<HelpCenterSettingsEmailAppEntryPointComponent>(
		/* webpackChunkName: "async-help-center-settings-email-app" */ './HelpCenterSettingsEmailEntryPoint.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: ({
		context: {
			match: {
				params: { helpCenterId },
			},
		},
		tenantContext: { cloudId, activationId },
	}: EntryPointRouteParams) => {
		const helpCenterAri = helpCenterId
			? HelpHelpCenterAri.create({ activationId, helpCenterId }).toString()
			: '';

		return {
			queries: {
				emailPreviewQuery: {
					parameters: HelpCenterSettingsEmailEntryPointQueryParameters,
					variables: {
						cloudId,
						helpCenterId: helpCenterAri,
						includeEmailUplift: fg('csm_ai_channel_aware_prompt_instructions'),
					},
					options: { fetchPolicy: 'store-or-network' as const },
				},
			},
		};
	},
});
